import { useSelector } from 'react-redux';
import { closeAppOutputDrawer } from '../redux/actions/uiActions/drawerActions';
import SliderHeader from './arguments/argumentOptionsSlider/SliderHeader';
import memoizeSelector from '@/redux/lib/memoizeSelector.js';
import AppEditorOutput from './AppEditorOutput';
import AppEditorOutputStateHandler from './AppEditorOutputStateHandler.jsx';

const AppEditorOutputDrawer = () => {
  const modalState = useSelector(memoizeSelector('appOutputDrawer', (state) => state.ui.appOutputDrawer));
  const { open, statusId } = modalState || {};

  return (
    <div className={`comp-argument-option-slider app-output-drawer ${open ? 'open' : ''}`}>
      <div className={'backing'} onClick={closeAppOutputDrawer} />
      <div className={'content'}>
        <SliderHeader title="Action Results" onClose={closeAppOutputDrawer} />
        <AppEditorOutput statusId={statusId} />
        <AppEditorOutputStateHandler />
      </div>
    </div>
  );
};

export default AppEditorOutputDrawer;
